import { render } from "./SelectSubpopulation.vue?vue&type=template&id=2220913c"
import script from "./SelectSubpopulation.vue?vue&type=script&lang=js"
export * from "./SelectSubpopulation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__